// Conditionally run code for local environments
export const isDevelopment = function() {
    return process && process.env && (process.env.NODE_ENV === 'development');
};

// Convert nodeList to Array
export const listToArray = function(node_list) {
    return Array.prototype.slice.call(node_list);
};

// Check for variable type
export const getVarType = function(object) {
    // Arrays
    if (Array.isArray(object)){
        return "array";
    }

    // String
    if (typeof(object) === "string"){
        return "string";
    }
    
    // Boolean
    if (typeof(object) === "boolean"){
        return "boolean";
    }

    // Undefined
    if (typeof(object) === "undefined"){
        return "undefined";
    }
    
    // Object
    return "object";
}